module.exports = __webpack_public_path__ + "img/superiority3.7c69d1a.png";